const SET_VALUE = 'instructionsVisible/SET_VALUE';

// reducer as default export
const instructionsVisible = (state = false, action) => {
  switch (action.type) {
    case SET_VALUE:
      return action.payload;
    default:
      return state;
  }
};

export default instructionsVisible;

// action creators
export const setValue = id => ({
  type: SET_VALUE,
  payload: id
});
